import React from "react";
import { useEffect, useState } from "react";
import { FILE_UPLOAD_STATUS } from "../utils/Constants";
import { Tooltip } from "react-tooltip";

const UploadStatusBar = ({ documents = [] }) => {
  const [uploadStats, setUploadStats] = useState({
    uploading: [],
    uploaded: [],
    processed: [],
    errored: [],
  });

  useEffect(() => {
    const stats = documents.reduce(
      (acc, doc) => {
        // Ensure we only process documents with valid filenames
        if (!doc || !doc.filename) {
          return acc;
        }

        switch (doc.status) {
          case FILE_UPLOAD_STATUS.uploading:
            acc.uploading.push(doc.filename);
            break;
          case FILE_UPLOAD_STATUS.uploaded:
            acc.uploaded.push(doc.filename);
            break;
          case FILE_UPLOAD_STATUS.processed:
            acc.processed.push(doc.filename);
            break;
          case FILE_UPLOAD_STATUS.errored:
            acc.errored.push(doc.filename);
            break;
          default:
            // Handle any unexpected status by treating as uploaded
            // This ensures all documents are counted
            acc.uploaded.push(doc.filename);
            break;
        }
        return acc;
      },
      {
        uploading: [],
        uploaded: [],
        processed: [],
        errored: [],
      }
    );
    setUploadStats(stats);
  }, [documents]);

  const getTotalFiles = () =>
    uploadStats.uploading.length +
    uploadStats.uploaded.length +
    uploadStats.processed.length +
    uploadStats.errored.length;

  const getSegmentWidth = count => {
    const total = getTotalFiles();
    return total > 0 ? (count / total) * 100 : 0;
  };

  return (
    <div className={"upload-status-bar"}>
      <div className={"upload-status-bar__progress"}>
        <div
          className={
            "upload-status-bar__segment upload-status-bar__segment--uploading"
          }
          style={{ width: `${getSegmentWidth(uploadStats.uploading.length)}%` }}
          data-tooltip-id="status-bar-uploading">
          {uploadStats.uploading.length > 0 && (
            <span className="upload-status-bar__count">
              {uploadStats.uploading.length}
            </span>
          )}
        </div>
        <Tooltip id="status-bar-uploading" place="top" delayShow={0}>
          Uploading:
          {uploadStats.uploading.map((filename, i) => (
            <div key={i}>{filename}</div>
          ))}
        </Tooltip>

        <div
          className={
            "upload-status-bar__segment upload-status-bar__segment--uploaded"
          }
          style={{ width: `${getSegmentWidth(uploadStats.uploaded.length)}%` }}
          data-tooltip-id="status-bar-uploaded">
          {uploadStats.uploaded.length > 0 && (
            <span className="upload-status-bar__count">
              {uploadStats.uploaded.length}
            </span>
          )}
        </div>
        <Tooltip id="status-bar-uploaded" place="top" delayShow={0}>
          Processing:
          {uploadStats.uploaded.map((filename, i) => (
            <div key={i}>{filename}</div>
          ))}
        </Tooltip>

        <div
          className={
            "upload-status-bar__segment upload-status-bar__segment--processed"
          }
          style={{ width: `${getSegmentWidth(uploadStats.processed.length)}%` }}
          data-tooltip-id="status-bar-processed">
          {uploadStats.processed.length > 0 && (
            <span className="upload-status-bar__count">
              {uploadStats.processed.length}
            </span>
          )}
        </div>
        <Tooltip id="status-bar-processed" place="top" delayShow={0}>
          Processed:
          {uploadStats.processed.map((filename, i) => (
            <div key={i}>{filename}</div>
          ))}
        </Tooltip>

        <div
          className={
            "upload-status-bar__segment upload-status-bar__segment--errored"
          }
          style={{ width: `${getSegmentWidth(uploadStats.errored.length)}%` }}
          data-tooltip-id="status-bar-errored">
          {uploadStats.errored.length > 0 && (
            <span className="upload-status-bar__count">
              {uploadStats.errored.length}
            </span>
          )}
        </div>
        <Tooltip id="status-bar-errored" place="top" delayShow={0}>
          Errored:
          {uploadStats.errored.map((filename, i) => (
            <div key={i}>{filename}</div>
          ))}
        </Tooltip>
      </div>
    </div>
  );
};

export default UploadStatusBar;
